/** Wire-friendly classification of the best visible `<video>` currentSrc/src. */
export type TVisibleVideoSrcScheme = 'blob' | 'http' | 'hls' | 'other'

/**
 * Classify a media URL for diagnostics (cache vs CDN vs HLS).
 * Null when there is no usable src (no element / empty string).
 */
export function resolveVisibleVideoSrcScheme(src: string | null | undefined): TVisibleVideoSrcScheme | null {
  if (src == null) {
    return null
  }
  const trimmed = src.trim()
  if (trimmed.length === 0) {
    return null
  }
  if (trimmed.startsWith('blob:')) {
    return 'blob'
  }
  if (/\.m3u8([?#]|$)/i.test(trimmed)) {
    return 'hls'
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return 'http'
  }
  return 'other'
}
